<template>
  <div>
    <ValidationObserver
      ref="form"
      v-slot="{ invalid, validate, dirty }">
      <form
        @submit.prevent="validate().then(updateSettings)"
        autocomplete="off">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <ValidationProvider
              name="Site Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                name="siteName"
                label="Site Name"
                type="text"
                v-model="siteName"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <!-- <el-divider /> -->
        <base-button
          :disabled="invalid || !dirty || isUnmodified"
          native-type="submit"
          type="primary"
          class="btn-fill">
          Update
        </base-button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Divider } from 'element-ui';

export default {
  name: 'SettingsGeneral',
  components: {
    ValidationObserver,
    ValidationProvider,
    [Divider.name]: Divider,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      siteName: this.settings.site_name,
    };
  },
  computed: {
    isUnmodified() {
      return this.siteName.trim() === this.settings.site_name;
    },
  },
  methods: {
    updateSettings() {
      this.$emit('updateSettings', {
        input: {
          site_name: this.siteName,
        },
      });
      this.$refs.form.reset();
    },
  },
};
</script>
